import { useState } from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Link, Outlet } from 'react-router-dom';
import { Heading } from '../../../../v2/js/components/heading';
import { MAIN_CONTENT_AREA } from '../../../../v2/js/utils/layoutStyles';
import { ProfileProgress } from '../../../app/components/ProfileProgress';
import { TabsNavbar } from '../../../app/components/TabsNavbar';
import { useCurrentUser } from '../../../app/hooks/auth';
import { useDocumentTitle } from '../../../app/hooks/use-document-title';
import { useUserProgress } from '../../../app/hooks/user-progress';
import { VisibilityModal } from '../../Registration/VisibilityModal';
import { VisibilityModalContext } from '../../Registration/VisibilityModalContext';

export const CurrentProfileEdit = () => {
  useDocumentTitle('Edit Provider Profile');
  const [showVisibilityModal, setShowVisibilityModal] = useState(false);
  const { user } = useCurrentUser();
  const { progress, isProfileComplete, lastStep } = useUserProgress(
    user?.provider_completed_registration_steps
  );

  return (
    <>
      <div className="tw:flex tw:h-[calc(100vh-72px)] tw:overflow-hidden">
        {/* Main content area */}
        <div className="tw:flex tw:flex-col tw:overflow-hidden tw:w-full">
          <main className={MAIN_CONTENT_AREA}>
            <Breadcrumb className="tw:mb-3">
              <Breadcrumb.Item
                linkAs={Link}
                linkProps={{
                  to: '/app/provider',
                }}
              >
                Your Profile
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Edit Profile</Breadcrumb.Item>
            </Breadcrumb>
            <div className="tw:flex tw:items-center tw:justify-between tw:mb-3">
              <Heading level={1} className="tw:!text-brand-green-0 tw:dark:!text-zinc-100">
                Edit Profile
              </Heading>
              {!isProfileComplete && <ProfileProgress progress={progress} />}
            </div>
            <TabsNavbar
              alignment="center"
              tabs={[
                {
                  label: 'Basic Info',
                  to: '/app/provider/edit',
                },
                {
                  label: 'Rates',
                  to: '/app/provider/edit/rates',
                },
                {
                  label: 'Professional Traits',
                  to: '/app/provider/edit/professional-traits',
                },
                {
                  label: 'Identification',
                  to: '/app/provider/edit/identification',
                },
                {
                  label: 'Education',
                  to: '/app/provider/edit/education',
                },
                {
                  label: 'Licenses',
                  to: '/app/provider/edit/licenses',
                },
                {
                  label: 'Other',
                  to: '/app/provider/edit/other',
                },
              ]}
            />
            <div className="tw:mt-4">
              <VisibilityModalContext.Provider
                value={{ showVisibilityModal, setShowVisibilityModal }}
              >
                <Outlet />
              </VisibilityModalContext.Provider>
            </div>
          </main>
        </div>
      </div>
      <VisibilityModal show={showVisibilityModal} onHide={() => setShowVisibilityModal(false)} />
    </>
  );
};
